import { FORCE_LOGIN_KEY } from './client-constants';
import { clearAuthCache, useNewAuthStore } from '@/store/use-new-auth-store';

let loggingOut = false;

/**
 * Terminal logout — gọi khi refresh chain fail trên 401 của WEB session
 * (refresh_token cũng invalid/expired).
 *
 * Trước đây 401 ở luồng web chỉ clear state ÂM THẦM (không toast, không redirect) →
 * user kẹt: API trả 401 nhưng UI vẫn "đang đăng nhập", không đặt đơn được mà cũng
 * không biết phiên đã hết hạn. Giờ:
 *   1. Clear store + auth cache + persisted storage + cookie server-side.
 *   2. Báo cho user (toast) biết phiên hết hạn.
 *   3. Đưa về trang chủ (same-origin) để UI về trạng thái đã đăng xuất → re-login.
 *
 * Idempotent: nhiều request 401 song song chỉ logout 1 lần (tránh toast/redirect lặp).
 * CHỈ dùng cho web (có refresh_token). Webinapp giữ phiên — KHÔNG gọi hàm này.
 */
export function terminalLogout() {
  if (loggingOut || typeof window === 'undefined') return;
  loggingOut = true;

  try {
    useNewAuthStore.getState().logout();
    clearAuthCache();
    try {
      // Tránh persist middleware hydrate lại user cũ; ép lần login kế tiếp hiện form.
      localStorage.removeItem('ahafood.new-auth');
      localStorage.setItem(FORCE_LOGIN_KEY, '1');
    } catch {
      /* ignore */
    }

    // Clear cookie ahafood server-side (đáng tin nhất).
    void fetch('/api/auth/logout', { method: 'POST' });

    void import('sonner').then(({ toast }) => {
      toast.error('Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.');
    });

    // Cho toast kịp hiển thị trước khi điều hướng về trang chủ.
    window.setTimeout(() => {
      window.location.replace('/');
    }, 1200);
  } catch {
    /* best-effort cleanup */
  }
}
